<template>
  <div class="d-flex justify-center flex-wrap pt-4 ga-4">
    <p
    class="ma-0"
    style="font-size: 20px; padding-left: 1px; font-style: italic; color: rgb(var(--v-theme-primary)) !important">
    A new core app update is available. Please update your version in the app store.
  </p>
  <Button
  class="w-100"
  :slim="true"
  version="primary"
  :label="btn_1_content"
  @click="handleUpdateClick"
  />
</div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';

import Button from '@/components/ComponentLibrary/Button.vue';
import { applyUpdate, openAppStorePage } from '@/services/mobile_app/liveUpdateService';
import { BundleInfo } from '@capgo/capacitor-updater';

const btn_1_content = ref('Take Me to the App Store');

const props = defineProps<{
  version: BundleInfo;
}>();

function handleUpdateClick() {
  openAppStorePage();
  applyUpdate(props.version);
}

</script>

<style lang="scss">

</style>